export function OutlineBellIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.9531 15.9984V18.9984H15.1115C14.5547 20.1792 13.3499 20.9952 11.9531 20.9952C10.5563 20.9952 9.35152 20.1792 8.79472 18.9984H2.95312V15.9984C4.05712 15.9984 4.95472 15.1008 4.95472 13.9968V9.9984C4.95472 6.1296 8.08912 3 11.9531 3C13.8827 3 15.6347 3.7824 16.9019 5.0496C18.1691 6.312 18.9515 8.064 18.9515 9.9984V13.9968C18.9515 15.1008 19.8491 15.9984 20.9531 15.9984Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
